import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, reduxForm } from 'redux-form'
import { injectStripe } from 'react-stripe-elements'
import history from '../../../../utils/routing/history'
import selectors from '../../../../store/shared/selectors'
import PaymentDisclaimer from '../../../../components/ui/typography/PaymentDisclaimer'
import * as stripeCardElements from '../../../../components/ui/forms/renderStripeCardElementInput'
import formValidators from '../../../../utils/validation/formValidators'
import notificationsUtils from '../../../../utils/notifications/notificationsUtils'
import * as currentUserDuck from '../../../../store/shared/currentUserDuck'
import applicationConstants from '../../../../utils/constants/application'
import * as paymentDuck from '../../../unauthenticated/Onboarding/paymentDuck'

// credit card images
import * as visa from '../../../../assets/onboarding/visa.png'
import * as discover from '../../../../assets/onboarding/discover.png'
import * as amex from '../../../../assets/onboarding/american-express.png'
import * as mastercard from '../../../../assets/onboarding/mastercard.png'

/**
 * Form Field Generator
 * @param params
 */
const createFormField = params => params.allowed && <Field {...params} />

class RecreateSubscriptionPaymentForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    isPerformingPaymentRequest: PropTypes.bool.isRequired,
    user: PropTypes.object,
  }

  render() {
    const { handleSubmit, invalid, pristine, isPerformingPaymentRequest, user } = this.props

    return (
      <div>
        <div style={{ marginBottom: '10px' }}>
          <div className="row">
            <div className="col">
              {createFormField({
                allowed: true,
                component: stripeCardElements.renderStripeCardNumber,
                name: '_cardNumberReady',
              })}
            </div>
          </div>
        </div>
        <div style={{ marginBottom: '10px' }}>
          <div className="row">
            <div className="col">
              {createFormField({
                allowed: true,
                component: stripeCardElements.renderStripeCardExpiry,
                name: '_cardExpiryReady',
              })}
            </div>
            <div className="col">
              {createFormField({
                allowed: true,
                component: stripeCardElements.renderStripeCardCVC,
                name: '_cardCVCReady',
              })}
            </div>
          </div>
        </div>
        <div style={{ marginBottom: '10px' }}>
          <div className="row">
            <div className="col">
              {createFormField({
                allowed: true,
                component: stripeCardElements.renderStripePostalCode,
                name: '_cardPostalCodeReady',
              })}
            </div>
          </div>
        </div>
        <div className="text-center" style={{marginTop: -10}}>
          <img alt="Visa" src={visa}/>&nbsp;
          <img alt="MasterCard" src={mastercard}/>&nbsp;
          <img alt="American Express" src={amex}/>&nbsp;
          <img alt="Discover" src={discover}/>
        </div>
        <PaymentDisclaimer />
        <div className="text-right">
          <h5 className="mb-0">Total Charge:</h5>
          <h2 className="mb-0">
            { user && user.stripe_plan_id_before_cancellation &&
              user.stripe_plan_id_before_cancellation === applicationConstants.stripe_plan_ids.INDIVIDUAL?
              <div>
                ${applicationConstants.stripe_plan_amounts.INDIVIDUAL}<sup>.00</sup>
              </div>
              :
              <span>
                ${applicationConstants.stripe_plan_amounts.PARENT}<sup>.00</sup>
              </span>
            }
          </h2>
        </div>
        <button
          className="btn btn-lg btn-block btn-success"
          disabled={invalid || pristine || isPerformingPaymentRequest}
          onClick={handleSubmit}
          style={{ marginTop: '20px' }}
        >
          {isPerformingPaymentRequest ? 'Reactivating...' : 'Activate Subscription!'}
        </button>
      </div>
    )
  }
}

/**
 * @const validate
 * @param values Form values to check
 * @returns {{}}
 */
const validate = values => {
  const errors = {}
  errors._cardNumberReady = formValidators.isRequired(values._cardNumberReady)
  errors._cardExpiryReady = formValidators.isRequired(values._cardExpiryReady)
  errors._cardCVCReady = formValidators.isRequired(values._cardCVCReady)
  errors._cardPostalCodeReady = formValidators.isRequired(
    values._cardPostalCodeReady,
  )

  return errors
}

/**
 * @const wrappedWithForm
 * @description Form decorated with reduxForm props
 */
const wrappedWithForm = reduxForm({
  form: 'updatePaymentForm',
  onSubmit: async (values, _dispatch, props) => {
    try {
      const { token } = await props.stripe.createToken()
      const user = await props.performRecreateSubscription({ stripe_card_token: token.id })
      props.currentUserSuccess(user)
      history.push('/app/dashboard')
    } catch (error) {
      notificationsUtils.showErrorNotification(error.message)
    }
  },
  validate,
})(RecreateSubscriptionPaymentForm)

const mapStateToProps = state => ({
  user: selectors.getCurrentUser(state),
  isPerformingCurrentUserRequest: false,
  isPerformingPaymentRequest: selectors.getIsPerformingRequest(state, 'payment'),
  isPerformingUserProfileRequest: false,
})

/**
 * @const mapDispatchToProps
 * @description Bind actions to props
 * @param dispatch
 */
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      currentUserSuccess: currentUserDuck.currentUserSuccess,
      performRecreateSubscription: paymentDuck.performRecreateSubscription,
    },
    dispatch,
  )

/**
 * @description Inject stripe provider, connect to Redux
 */
export default injectStripe(
  connect(mapStateToProps, mapDispatchToProps)(wrappedWithForm),
)



// WEBPACK FOOTER //
// ./src/routes/authenticated/RecreateSubscription/components/RecreateSubscriptionPaymentForm.js